import { IconButton } from '@material-ui/core';
import ContainerGraphModal from 'components/ContainerGraphModal';
import FeatherIcon from 'components/custom/FeatherIcon';
import { useActiveSession } from 'modules/sessions';
import React, { useState } from 'react';
import IntlMessages from 'utils/IntlMessages';

const PLInfoModal = ( { className = '' } ) => {
  const [open, setOpen] = useState( false );
  const { activeSession } = useActiveSession();
  const isEnterprise = activeSession && activeSession.distributionType === 'enterprise';
  return (
    <>
      <IconButton
        color="primary"
        className={`square-icon-button-primary2 ${className}`}
        onClick={() => setOpen( !open )}
      >
        <FeatherIcon icon="info" color="primary2.main" size="18px" />
      </IconButton>

      <ContainerGraphModal
        title="ProfitLossStatement"
        open={open}
        onClose={() => setOpen( false )}
      >
        <div className="p-3  mt-3">
          <p className="">
            <b className="text-primary">
              <IntlMessages id="RevenuesFromGoodSold" />
            </b>
            {' '}
            :
            {' '}
            <IntlMessages id="plInfoProducts" />
          </p>
          {isEnterprise && (
            <>
              <br />

              <p>
                <b className="text-primary">
                  <IntlMessages id="RevenuesFromServ" />
                </b>
                {' '}
                :
                {' '}
                <IntlMessages id="plInfoServices" />
              </p>
            </>
          )}

          {isEnterprise && (
            <>
              <br />

              <p>
                {' '}
                <b className="text-primary">
                  <IntlMessages id="RevenuesFromBundlesSales" />
                </b>
                {' '}
                :
                {' '}
                <IntlMessages id="plInfoBundles" />
              </p>
            </>
          )}
        </div>
      </ContainerGraphModal>
    </>
  );
};

export default PLInfoModal;
